export default __webpack_public_path__ + "static/media/beartariaTimes.b6edf902.png";